import { z } from "zod";

export const CodeSchema = z.object({
  table: z.number(),
  num: z.number(),
  name: z.string(),
  abbrev: z.string(),
  systemRequired: z.boolean(),
});

export const CodeListSchema = z.array(CodeSchema);

export const CodeTableSchema = z.object({
  name: z.string(),
  tableNum: z.number(),
  codes: CodeListSchema,
});

export const CodeTableListSchema = z.array(CodeTableSchema);

export type Code = z.infer<typeof CodeSchema>;
export type CodeTable = z.infer<typeof CodeTableSchema>;
